<template>
    <div>
        <div class="mb-3">          
            <el-collapse>
                <el-collapse-item>
                    <template slot="title">
                        <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                    </template>
                    <el-form label-position="top" label-width="100px">
                        <div class="row">
                            <div class="col-md-6" v-if="tabName != 'service' && tabName != 'outlet' " v-show="true">
                                <el-form-item label="Location">
                                    <el-radio-group v-model="detail1" size="small">
                                        <el-radio-button :label="item2.value" v-for="(item2, index2) in options.detail1" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                            <div class="col-md-6" v-if="tabName != 'service' && tabName != 'outlet' ">
                                <el-form-item label="Cafe">
                                    <el-select v-model="branch" clearable filterable placeholder="Select Cafe" size="small" style="width:100%;">
                                        <el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="col-md-6" v-if="tabName != 'stock' && tabName != 'service' && tabName !='outlet' ">
                                <el-form-item label="Date" style="max-width: 250px;">
                                    <el-date-picker
                                        size="small"
                                        v-model="date"
                                        type="daterange"
                                        align="right"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :start-placeholder="date.Start"
                                        :end-placeholder="date.End"
                                        :default-value="date.End">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
   
                            <div class="col-md-6" v-if="tabName != 'stock' && tabName != 'service' && tabName != 'outlet' " v-show="false">
                                <el-form-item label="Type">
                                    <el-radio-group v-model="nfrtype" size="small">
                                        <el-radio-button :label="item4.value" v-for="(item4, index4) in options.nfrtype" :key="item4.value+'_'+index4" style="margin-left:0px;">{{item4.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                            <div class="col-md-6" v-if="is2024OrBelow && tabName != 'service' ">
                                <el-form-item label="Area">
                                    <el-radio-group v-model="area" size="small">
                                        <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                            <div class="col-md-6" v-if="is2025OrAbove && tabName != 'service' && tabName !='outlet' ">
                                <el-form-item label="Region">
                                    <el-radio-group v-model="region" size="small">
                                        <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                       
                            <div class="col-md-6" v-if="tabName != 'stock' && tabName != 'service'">
                                <el-form-item label="Period">
                                    <el-radio-group v-model="periode" size="small">
                                        <el-radio-button :label="item6.value" v-for="(item6, index6) in options.periode" :key="item6.value+'_'+index6" style="margin-left:0px;">{{item6.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
        
                            <div class="col-md-6" v-if="tabName != 'spd' && tabName != 'service' && tabName != 'outlet' ">
                                <el-form-item label="Items">
                                    <el-radio-group v-model="detail2" size="small">
                                        <el-radio-button :label="item7.value" v-for="(item7, index7) in options.detail2" :key="item7.value+'_'+index7" style="margin-left:0px;">{{item7.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                            <div class="col-md-12" v-if="tabName == 'service'">
                                <el-form-item label="Service Level Type">
                                    <el-radio-group v-model="sltype" size="small">
                                        <el-radio-button :label="item8.value" v-for="(item8, index8) in options.sltype" :key="item8.value+'_'+index8" style="margin-left:0px;">{{item8.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                            <div class="col-md-12" v-if="tabName == 'service'">
                                <el-form-item label="Fill (%)">
                                    <el-radio-group v-model="sltypeline" size="small">
                                        <el-radio-button :label="item9.value" v-for="(item9, index9) in options.sltypeline" :key="item9.value+'_'+index9" style="margin-left:0px;">{{item9.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <el-button type="success" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                            </div>
                        </div>
                    </el-form>

                </el-collapse-item>
            </el-collapse>
        </div>
        
        <div class="row">
            <div class="col-md-3">
                <el-checkbox v-model="showchart">Show Chart</el-checkbox>
            </div>
            <div class="col-md-4" v-if="showchart">
                <el-radio-group v-model="charttype">
                    <el-radio label="barchart" size="small">Bar Chart</el-radio>
                    <el-radio label="linechart" size="small">Line Chart</el-radio>
                </el-radio-group>
            </div>
            
        </div>
        <div class="mb-3" >
            <BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="350" v-if="showchart && charttype=='barchart'" />
            <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
        </div>
        <ReportResultTable :reportname="'BrightReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess"/>      
    </div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import {Rainbow, Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'


export default
{
	extends:Cafe,
	components: {
        ReportResultTable,
        BarChart,
        LineChart,
    },
    props: ['tabIndex','tabName', 'tabLabel'],
    computed:{
	},
    watch:{
        date(newValue, oldValue) {
			let yearCategory = this.getYearCategory(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = 'region';
				this.area = '';
				//this.salescharttype = 'saleschartregion'
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
				this.area = 'area';
				//this.salescharttype = 'saleschartarea'
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = 'region';
				this.area = 'area';
				//this.salescharttype = 'saleschartall'
			} 
			
			//console.log('area: ' + this.area);
			//console.log('region: ' + this.region);
		},
    },
    mounted(){

        if(this.tabName == 'outlet') {
            this.options.periode = [
                { value: '', name: 'ALL' },
                //{ value: 'daily', name: 'DAILY' },
                //{ value: 'weekly', name: 'WEEKLY' },
                { value: 'monthly', name: 'MONTHLY'  },
                { value: 'yearly', name: 'YEARLY' },
            ]
        }
        this.loadStoreList()
        //this.resumePilihan()
    },
    data() {
		return {
            tabActiveName: 'sales',
            /*
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},*/
            date: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],
			urlRequestParams: '',
			options: {
				periode:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'weekly', name: 'WEEKLY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "store", name: "BY CAFE" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "div", name: "BY DIVISI" }, 
					{ value: "dep", name: "BY DEPARTMENT" },
					{ value: "item", name: "BY ITEM" }
				],
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
                region:[
					{ value: "", name: "ALL" }, 
					{ value: "region", name: "BY REGION", field: "RegionPertareId" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
					{ value: "6", name: "6" }, 
					{ value: "7", name: "7" }, 
				],
				nfrtype:[
					{ value: "", name: "ALL" }, 
					//{ value: "nfrtype", name: "BY TYPE", field: "BranchType1" },  //name: "BY TYPE"
					{ value: "BRIGHT", name: "STORE" }, 
					{ value: "CAFE", name: "CAFE" }, 
				],
                sltype:[
					//{ value: "", name: "ALL" }, 
					//{ value: "weekly", name: "WEEKLY" }, 
					//{ value: "totalweekly", name: "TOTAL WEEKLY" },
					{ value: "sls", name: "SERVICE LEVEL SUPPLIER" },
                    { value: "slsd", name: "SERVICE LEVEL SUPPLIER DC" },
                    { value: "sld", name: "SERVICE LEVEL DC" },
				],
                sltypeline:[
                    { value: "casefill", name: "CASE FILL" },
                    { value: "linefill", name: "LINE FILL" },
				],
			}, 
            charttype: 'barchart',
			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: false,
			branch: this.$route.query.branch ? this.$route.query.branch : '',
            periode: this.$route.query.period ? this.$route.query.period : 'monthly',
            detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
            detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
            area: this.$route.query.area ? this.$route.query.area : '',
            region: this.$route.query.region ? this.$route.query.region : 'region',
			sltype: this.$route.query.sltype ? this.$route.query.sltype : 'sls',
            sltypeline: this.$route.query.sltypeline ? this.$route.query.sltypeline : 'casefill', //'casefill',
            nfrtype: this.$route.query.nfrtype ? this.$route.query.nfrtype : 'CAFE',
            loading: {
                table: false,
                chart: false,
                isSuccess: false, //is request success or error
            },

            is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,
        }
    },
    methods:{

        async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/cafe/sales?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/cafe/basket?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/cafe/shrinkage?' //?
            else if (this.tabIndex == 3) this.urlRequestParams+='/cafe/performance?'
            else if (this.tabIndex == 4) this.urlRequestParams+='/cafe/stock-detail?' 
            else if (this.tabIndex == 5) this.urlRequestParams+='/cafe/service-level?'

            if (this.tabName == 'outlet') this.urlRequestParams+='/v1/cafe/pertumbuhanOutlet?'

			this.urlRequestParams+='&date-range-start='+this.date[0] //this.date.Start
			this.urlRequestParams+='&date-range-end='+this.date[1] //this.date.End
			this.urlRequestParams+='&period='+this.periode
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&nfrtype='+this.nfrtype
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2
			this.urlRequestParams+='&branch='+this.branch

            //for service level weekly
            this.urlRequestParams+='&count=8' 
            this.urlRequestParams+='&sltype='+this.sltype

			this.loading.table = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    this.loading.isSuccess = true
					this.reportdata = response.data;

                    this.setBarChart(response.data)
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.table = false;
				})
		},

        setBarChart(data) {
            if(this.tabName == 'sales') {
                let prefix = "AREA " //AREA

                if(this.region) 
                    prefix = "REGION ";

                let label = "DivisiName"
                let legend = "Period"
                let valuecol = "TotalSalesExTax"
                if (this.detail2 == 'dep') {
                    prefix = ""
                    label = "DepartmentName"
                } else if (this.detail2 == 'div') {
                    prefix = ""
                    label = "DivisiName"
                } else if (this.detail2 == 'item') {
                    prefix = ""
                    label = "ItemName"
                }else if (this.detail2 == '') {
                    if(this.region) 
                        label = "RegionPertareId"
                    else
                        label = "SalesArea"
                }
                console.log('label sales: ' + label)

                if(this.periode == 'daily') legend = 'Period'
                else if(this.periode == 'weekly') {
                    //prefix = "WK "
                    legend = 'Period'
                } else if(this.periode == 'monthly') legend = 'Period'             
                else if(this.periode == 'yearly') legend = 'Period'
                else if(this.periode == ''){
                    //prefix = "DAY "
                    legend = 'NumDay'
                }

                if (this.detail2 == 'item') {
                    this.chartdata = this.processBarChart(data.data, legend, prefix, valuecol, false, label, "", 1, 2, Rainbow, false, false, false)
                } else {
                    this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)
                }
                
            } else if(this.tabName == 'spd' || this.tabName == 'store') {
                let prefix = "AREA "
                let label = "SalesArea"
                let legend = "Period"
                let valuecol = "SalesPerDay"
                //console.log('label spd: ' + label)

                if(this.region) {
                    prefix = "REGION ";
                    label = "RegionPertareId";
                }

                if(this.periode == 'daily') legend = 'Period'
                else if(this.periode == 'weekly') {
                    //prefix = "WK "
                    legend = 'Period'
                } else if(this.periode == 'monthly') legend = 'Period'             
                else if(this.periode == 'yearly') legend = 'Period'
                else if(this.periode == ''){
                    //prefix = "DAY "
                    legend = 'NumDay'
                }

                this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)
            } else if(this.tabName == 'waste') {
                let prefix = "AREA "
                let label = "DivisiName"
                let legend = "Period"
                let valuecol = "SubTotal"
                if (this.detail2 == 'dep') label = "DepartmentName"
                else if (this.detail2 == 'div') label = "DivisiName"
                else if (this.detail2 == 'item') label = "ItemName"
                else if (this.detail2 == '') {
                    label = "SalesArea"

                    if(this.region) {
                        prefix = "REGION ";
                        label = "RegionPertareId";
                    }
                }
                //console.log('label waste: ' + label)

                if(this.periode == 'daily') legend = 'Period'
                else if(this.periode == 'weekly') {
                    //prefix = "WK "
                    legend = 'Period'
                } else if(this.periode == 'monthly') legend = 'Period'             
                else if(this.periode == 'yearly') legend = 'Period'
                else if(this.periode == ''){
                    //prefix = "DAY "
                    legend = 'NumDay'
                }

                this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)
            } else if(this.tabName == 'stock') {
                let prefix = " " //AREA
                let label = "DivisiName"
                let legend = "SalesArea"
                let valuecol = "TotalStockValue"
                if (this.detail2 == 'dep') label = "DepartmentName"
                else if (this.detail2 == 'div') label = "DivisiName"
                else if (this.detail2 == 'item') label = "ItemName"
                else if (this.detail2 == '') label = "StockLabel"
                //console.log('label stock: ' + label)

                this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)
            } else if(this.tabName == 'service') {
                let prefix = "AREA " //WK 
                let label = "BranchType"
                let legend = "WeekNo"
                let valuecol = "CaseFillPct"
                if (this.sltype == 'sls') label = "BranchType"
                else if (this.sltype == 'slsd') label = "BranchName"
                else if (this.sltype == 'sld') label = "DCName"

                if(this.sltypeline =='linefill') valuecol = "LineFillPct"

                //console.log('label service: ' + label)

                this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)
            } else if (this.tabName == 'outlet') {
                let prefix = "" //WK 
                let label = "legend"
                let legend = "label"
                let valuecol = "Jumlah_store"
                this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)
            }
                
        },

        refreshChart() {
			let opt = this.getoption(this.nfrtype, this.options.nfrtype)
			let a = opt && opt.field ? opt.field : a
			let prefix = ""
			
			opt = this.getoption(this.area, this.options.area)
			if (opt && opt.field) {
				a = opt.field
				prefix = "AREA "
			}
			
			let b = "Period"
			let c = Rainbow

			let valuecol = ""
			if (this.tabIndex == 0) valuecol = "TotalSalesExTax"
			else if (this.tabIndex == 1) valuecol = "SalesPerDay"
			else if (this.tabIndex == 2) valuecol = "SubTotal"

            if (this.tabName == 'outlet') {
                a = "label" //label
                b = "legend" //legend
                valuecol = "Jumlah_store"
            }
			
			this.chartdata = this.processBarChart(this.reportdata.data, a, prefix, valuecol, false, b, "", 1000000, 2, c, false, false, false, this.stacked);
		},

        applyFilter() {
            this.resumePilihan()
        },
    },
}

</script>


<style>
.el-tabs--border-card {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 0 0px 0 rgb(0 0 0 / 0%) !important;
    /* box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%); */
}

.el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0px !important;
    line-height: 20px !important;
}

label, .form-label {
    font-size: 0.75rem;
    font-weight: 500 !important; /** 700 */
    margin-bottom: 0.0rem !important; /** 0.5rem */
    color: #252f40;
    margin-left: 0.0rem !important;
    /*margin-left: 0.25rem; original*/
}

.el-form-item {
    margin-bottom: 12px !important;
}

.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 100% !important;
}
</style>